/**
 * HUMANSTARSapp
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const NotificationActionType = {
    CalendarEventConfirmation: 'calendar-event-confirmation'
} as const;
export type NotificationActionType = typeof NotificationActionType[keyof typeof NotificationActionType];

